import {
  MascheraDispositivo,
  RegistriMode,
  RegistroDto,
  UpdateRegistroDto,
} from "@/api";
import {
  EditorRegistriGFLTFL700,
  formGFLTFL700ToRegistri,
  registriGFLTFL700ToForm,
} from "@/components/DispositivoDetails/maschere/registri/GFLTFL700";
import {
  EditorRegistri_GFL_MONITORING_WTP,
  formToRegistri_GFL_MONITORING_WTP,
  registriToForm_GFL_MONITORING_WTP,
} from "@/components/DispositivoDetails/maschere/registri/GFL_MONITORING_WTP";
import {
  EditorRegistri_GFL_MONITORING_WT,
  formToRegistri_GFL_MONITORING_WT,
  registriToForm_GFL_MONITORING_WT,
} from "@/components/DispositivoDetails/maschere/registri/GFL_MONITORING_WT";
import {
  EditorRegistri_GFL_SENSOR_WT,
  formToRegistri_GFL_SENSOR_WT,
  registriToForm_GFL_SENSOR_WT,
} from "@/components/DispositivoDetails/maschere/registri/GFL_SENSOR_WT";
import {
  EditorRegistri_PRAEVIDERE_GRADUS_35,
  formToRegistri_PRAEVIDERE_GRADUS_35,
  registriToForm_PRAEVIDERE_GRADUS_35,
} from "@/components/DispositivoDetails/maschere/registri/PRAEVIDERE_GRADUS_35";
import {
  EditorRegistri_PRAEVIDERE_VIBRATIO_35,
  formToRegistri_PRAEVIDERE_VIBRATIO_35,
  registriToForm_PRAEVIDERE_VIBRATIO_35,
} from "@/components/DispositivoDetails/maschere/registri/PRAEVIDERE_VIBRATIO_35";
import {
  EditorRegistri_GFL_DFA_3500,
  formToRegistri_GFL_DFA_3500,
  registriToForm_GFL_DFA_3500,
} from "@/components/DispositivoDetails/maschere/registri/GFL_DFA_3500";
import { ResetOnlyButtons } from "@/components/DispositivoDetails/maschere/buttons/ResetOnlyButtons";
import { StartStopResetButtons } from "@/components/DispositivoDetails/maschere/buttons/StartStopResetButtons";
import { GFL_DFA_3500_Buttons } from "@/components/DispositivoDetails/maschere/buttons/GFL_DFA_3500_Buttons";
import {
  EditorRegistri_GFL_TLV_300,
  formToRegistri_GFL_TLV_300,
  registriToForm_GFL_TLV_300,
} from "@/components/DispositivoDetails/maschere/registri/GFL_TLV_300";
import { GFL_TLV_300_Buttons } from "@/components/DispositivoDetails/maschere/buttons/GFL_TLV_300_Buttons";
import { BANCO_DI_FLUSSAGGIO_Buttons } from "@/components/DispositivoDetails/maschere/buttons/BANCO_DI_FLUSSAGGIO_Buttons";
import { GFL_TH_4000_Buttons } from "@/components/DispositivoDetails/maschere/buttons/GFL_TH_4000_Buttons";
import {
  EditorRegistri_GFL_MONITORING_EM,
  formToRegistri_GFL_MONITORING_EM,
  registriToForm_GFL_MONITORING_EM,
} from "@/components/DispositivoDetails/maschere/registri/GFL_MONITORING_EM";
import {
  EditorRegistri_BANCO_DI_FLUSSAGGIO,
  formToRegistri_BANCO_DI_FLUSSAGGIO,
  registriToForm_BANCO_DI_FLUSSAGGIO,
} from "@/components/DispositivoDetails/maschere/registri/BANCO_DI_FLUSSAGGIO";
import {
  EditorRegistri_BANCO_DI_FLUSSAGGIO_2,
  formToRegistri_BANCO_DI_FLUSSAGGIO_2,
  registriToForm_BANCO_DI_FLUSSAGGIO_2,
} from "@/components/DispositivoDetails/maschere/registri/BANCO_DI_FLUSSAGGIO_2";
import {
  EditorRegistri_GFL_TH_4000,
  formToRegistri_GFL_TH_4000,
  registriToForm_GFL_TH_4000,
} from "@/components/DispositivoDetails/maschere/registri/GFL_TH_4000";
import {
  EditorRegistri_GFL_TFLD_550_2,
  formToRegistri_GFL_TFLD_550_2,
  registriToForm_GFL_TFLD_550_2,
} from "@/components/DispositivoDetails/maschere/registri/GFL_TFLD_550_2";
import { GFL_TFLD_550_2_Buttons } from "@/components/DispositivoDetails/maschere/buttons/GFL_TFLD_550_2_Buttons";
import { GFL_TFLD_550_2_Info } from "./info/GFL_TFLD_550_2_Info";
import { InfoContaOre } from "./info/InfoContaOre";
import { GFL_DFA_3500_Info } from "./info/GFL_DFA_3500_Info";
import { BANCO_DI_FLUSSAGGIO_Info } from "./info/BANCO_DI_FLUSSAGGIO_Info";
import { GFL_TH_4000_Info } from "./info/GFL_TH_4000_Info";
import RegistriNexusDialog from "../RegistriNexusDialog";

export type MascheraDispositivoHelper<Data = Record<string, any>> = {
  maschera: MascheraDispositivo;

  ButtonsComponent: any;
  InfoComponent: any;
  statusManuale?: string[];
} & (
  | {
      MascheraComponent: any;
      registriToForm: (registri: RegistroDto[]) => Data;
      formToRegistri: (registri: Data) => UpdateRegistroDto[];
      mode: RegistriMode;
      autocloseAfterSave: boolean;
    }
  | { DialogComponent: any }
);

const mascheraDispositivoHelpers: {
  [m in MascheraDispositivo]: MascheraDispositivoHelper;
} = {
  GFL_TFL_700: generateHelper("GFL_TFL_700"),
  GFL_MONITORING_WTP: generateHelper("GFL_MONITORING_WTP"),
  GFL_MONITORING_WT: generateHelper("GFL_MONITORING_WT"),
  GFL_SENSOR_WT: generateHelper("GFL_SENSOR_WT"),
  PRAEVIDERE_GRADUS_35: generateHelper("PRAEVIDERE_GRADUS_35"),
  PRAEVIDERE_VIBRATIO_35: generateHelper("PRAEVIDERE_VIBRATIO_35"),
  GFL_DFA_3500: generateHelper("GFL_DFA_3500"),
  GFL_TLV_300: generateHelper("GFL_TLV_300"),
  GFL_MONITORING_EM: generateHelper("GFL_MONITORING_EM"),
  BANCO_DI_FLUSSAGGIO: generateHelper("BANCO_DI_FLUSSAGGIO"),
  BANCO_DI_FLUSSAGGIO_2: generateHelper("BANCO_DI_FLUSSAGGIO_2"),
  GFL_TH_4000: generateHelper("GFL_TH_4000"),
  NEXUS_6D: generateHelper("NEXUS_6D"),
  GFL_TFLD_550_2: generateHelper("GFL_TFLD_550_2"),
} as const;

export function getMascheraDispositivoHelper(
  maschera: MascheraDispositivo,
): MascheraDispositivoHelper | null {
  const h = mascheraDispositivoHelpers[maschera];
  if (!h) {
    console.error("[MascheraDispositivoHelper] Unknown maschera: " + maschera);
  }
  return h || null;
}

// -------------------------------------------------
// -------------------------------------------------
// -------------------------------------------------

function generateHelper(m: MascheraDispositivo): MascheraDispositivoHelper {
  if (m === "GFL_TFL_700") {
    return {
      maschera: m,
      ButtonsComponent: StartStopResetButtons,
      InfoComponent: InfoContaOre,
      MascheraComponent: EditorRegistriGFLTFL700,
      registriToForm: registriGFLTFL700ToForm,
      formToRegistri: formGFLTFL700ToRegistri,
      mode: "ManyTopics",
      autocloseAfterSave: true,
    };
  } else if (m === "GFL_MONITORING_WTP") {
    return {
      maschera: m,
      InfoComponent: null,
      ButtonsComponent: ResetOnlyButtons,
      MascheraComponent: EditorRegistri_GFL_MONITORING_WTP,
      registriToForm: registriToForm_GFL_MONITORING_WTP,
      formToRegistri: formToRegistri_GFL_MONITORING_WTP,
      mode: "SingleJsonMessage",
      autocloseAfterSave: true,
    };
  } else if (m === "GFL_MONITORING_WT") {
    return {
      maschera: m,
      InfoComponent: null,
      ButtonsComponent: ResetOnlyButtons,
      MascheraComponent: EditorRegistri_GFL_MONITORING_WT,
      registriToForm: registriToForm_GFL_MONITORING_WT,
      formToRegistri: formToRegistri_GFL_MONITORING_WT,
      mode: "SingleJsonMessage",
      autocloseAfterSave: true,
    };
  } else if (m === "GFL_SENSOR_WT") {
    return {
      maschera: m,
      InfoComponent: null,
      ButtonsComponent: ResetOnlyButtons,
      MascheraComponent: EditorRegistri_GFL_SENSOR_WT,
      registriToForm: registriToForm_GFL_SENSOR_WT,
      formToRegistri: formToRegistri_GFL_SENSOR_WT,
      mode: "SingleJsonMessage",
      autocloseAfterSave: true,
    };
  } else if (m === "PRAEVIDERE_GRADUS_35") {
    return {
      maschera: m,
      InfoComponent: null,
      ButtonsComponent: ResetOnlyButtons,
      MascheraComponent: EditorRegistri_PRAEVIDERE_GRADUS_35,
      registriToForm: registriToForm_PRAEVIDERE_GRADUS_35,
      formToRegistri: formToRegistri_PRAEVIDERE_GRADUS_35,
      mode: "SingleJsonMessage",
      autocloseAfterSave: true,
    };
  } else if (m === "PRAEVIDERE_VIBRATIO_35") {
    return {
      maschera: m,
      InfoComponent: null,
      ButtonsComponent: ResetOnlyButtons,
      MascheraComponent: EditorRegistri_PRAEVIDERE_VIBRATIO_35,
      registriToForm: registriToForm_PRAEVIDERE_VIBRATIO_35,
      formToRegistri: formToRegistri_PRAEVIDERE_VIBRATIO_35,
      mode: "SingleJsonMessage",
      autocloseAfterSave: true,
    };
  } else if (m === "GFL_DFA_3500") {
    return {
      maschera: m,
      ButtonsComponent: GFL_DFA_3500_Buttons,
      MascheraComponent: EditorRegistri_GFL_DFA_3500,
      InfoComponent: GFL_DFA_3500_Info,
      registriToForm: registriToForm_GFL_DFA_3500,
      formToRegistri: formToRegistri_GFL_DFA_3500,
      statusManuale: [
        "on-manuale",
        "on-manuale diso",
        "on-manuale filt",
        "on pompe manuale",
      ],
      mode: "ManyTopics",
      autocloseAfterSave: true,
    };
  } else if (m === "GFL_TLV_300") {
    return {
      maschera: m,
      ButtonsComponent: GFL_TLV_300_Buttons,
      MascheraComponent: EditorRegistri_GFL_TLV_300,
      InfoComponent: InfoContaOre,
      registriToForm: registriToForm_GFL_TLV_300,
      formToRegistri: formToRegistri_GFL_TLV_300,
      statusManuale: [
        "Flussaggio ON",
        "Flussaggio e Ricircolo ON",
        "Flussaggio e Contaparticelle ON",
        "Ricircolo ON",
      ],
      mode: "ManyTopics",
      autocloseAfterSave: true,
    };
  } else if (m === "GFL_MONITORING_EM") {
    return {
      maschera: m,
      InfoComponent: null,
      ButtonsComponent: ResetOnlyButtons,
      MascheraComponent: EditorRegistri_GFL_MONITORING_EM,
      registriToForm: registriToForm_GFL_MONITORING_EM,
      formToRegistri: formToRegistri_GFL_MONITORING_EM,
      mode: "SingleJsonMessage",
      autocloseAfterSave: true,
    };
  } else if (m === "BANCO_DI_FLUSSAGGIO") {
    return {
      maschera: m,
      ButtonsComponent: BANCO_DI_FLUSSAGGIO_Buttons,
      MascheraComponent: EditorRegistri_BANCO_DI_FLUSSAGGIO,
      InfoComponent: BANCO_DI_FLUSSAGGIO_Info,
      registriToForm: registriToForm_BANCO_DI_FLUSSAGGIO,
      formToRegistri: formToRegistri_BANCO_DI_FLUSSAGGIO,
      mode: "ManyTopics",
      autocloseAfterSave: false,
    };
  } else if (m === "BANCO_DI_FLUSSAGGIO_2") {
    return {
      maschera: m,
      ButtonsComponent: BANCO_DI_FLUSSAGGIO_Buttons, // per ora non cambia questo
      MascheraComponent: EditorRegistri_BANCO_DI_FLUSSAGGIO_2,
      InfoComponent: BANCO_DI_FLUSSAGGIO_Info, // per ora non cambia questo
      registriToForm: registriToForm_BANCO_DI_FLUSSAGGIO_2,
      formToRegistri: formToRegistri_BANCO_DI_FLUSSAGGIO_2,
      mode: "ManyTopics",
      autocloseAfterSave: false,
    };
  } else if (m === "GFL_TH_4000") {
    return {
      maschera: m,
      ButtonsComponent: GFL_TH_4000_Buttons,
      MascheraComponent: EditorRegistri_GFL_TH_4000,
      InfoComponent: GFL_TH_4000_Info,
      registriToForm: registriToForm_GFL_TH_4000,
      formToRegistri: formToRegistri_GFL_TH_4000,
      statusManuale: [],
      mode: "ManyTopics",
      autocloseAfterSave: false,
    };
  } else if (m === "GFL_TFLD_550_2") {
    return {
      maschera: m,
      ButtonsComponent: GFL_TFLD_550_2_Buttons,
      MascheraComponent: EditorRegistri_GFL_TFLD_550_2,
      InfoComponent: GFL_TFLD_550_2_Info,
      registriToForm: registriToForm_GFL_TFLD_550_2,
      formToRegistri: formToRegistri_GFL_TFLD_550_2,
      statusManuale: [],
      mode: "ManyTopics",
      autocloseAfterSave: false,
    };
  } else if (m === "NEXUS_6D") {
    return {
      maschera: m,
      ButtonsComponent: null,
      InfoComponent: null,
      DialogComponent: RegistriNexusDialog,
      autocloseAfterSave: true,
    };
  } else {
    throw new Error("maschera sconosciuta");
  }
}
